<template>
  <div>
    <el-popover
        placement="bottom"
        width="200"
        trigger="click">
      <div class="flex">
        <div @click="changeTheme('#285af1','#001223','#11436f')" class="h-20 w-20 ml-1"
             style="background-color: #285af1"></div>
        <div @click="changeTheme('#3eaf7c','#091A12','#1c5038')" class="h-20 w-20 ml-1"
             style="background-color: #3eaf7c"></div>
        <div @click="changeTheme('#13c2c2','#031c1c','#0b5e5e')" class="h-20 w-20 ml-1"
             style="background-color: #13c2c2"></div>
        <div @click="changeTheme('#722ed1','#10071f','#2c1152')" class="h-20 w-20 ml-1"
             style="background-color: #722ed1"></div>
        <div @click="changeTheme('#dc03fe','#10071f','#40226a')" class="h-20 w-20 ml-1"
             style="background-color: #dc03fe"></div>
      </div>
      <el-button type="text" slot="reference" style="color: #f6fdfd">主题</el-button>
    </el-popover>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
const version = require('element-ui/package.json').version
import {getValue, setValue} from '@/utils/localStorage'
import {chalk} from '@/utils/theme_css'

const ORIGINAL_THEME = '#409EFF'
export default {
  name: "ThemeSelect",
  data() {
    return {
      chalk: chalk
    }
  },
  created() {
    this.initTheme()
  },
  methods: {
    initTheme() {
      let themeJson = getValue("theme");
      if (themeJson) {
        let th = JSON.parse(themeJson);
        this.setTheme(th.mainTheme);
        this.$store.dispatch("changeTheme", th)
      } else {
        themeJson = {
          mainTheme: "#285af1",
          sideTheme: "#031c1c",
          logoTheme: "#0b5e5e",
          headerTheme: "#031c1c"
        }
        this.setTheme(themeJson.mainTheme);
        this.$store.dispatch("changeTheme", themeJson)
      }
    },

    changeTheme(mainTheme, sideTheme, logoTheme, headerTheme) {
      headerTheme = sideTheme;
      this.setTheme(mainTheme);
      setValue("theme", JSON.stringify({mainTheme, sideTheme, logoTheme, headerTheme}));
      this.$store.dispatch("changeTheme", {mainTheme, sideTheme, logoTheme, headerTheme})
    },

    async setTheme(val) {
      if (typeof val !== 'string') return
      let oldVal;
      let themeJson = getValue("theme");
      if (themeJson) {
        let th = JSON.parse(themeJson);
        oldVal = th.mainTheme;
      } else {
        oldVal = "#0A1E29"
      }
      const themeCluster = this.getThemeCluster(val.replace('#', ''))
      const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))
      const getHandler = (variable, id) => {
        return () => {
          const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
          const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)

          let styleTag = document.getElementById(id)
          if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.setAttribute('id', id)
            document.head.appendChild(styleTag)
          }
          styleTag.innerText = newStyle
        }
      }

      // if (!this.chalk) {
      //   const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
      //   await this.getCSSString(url, 'chalk')
      // }

      const chalkHandler = getHandler('chalk', 'chalk-style')
      chalkHandler()
      const styles = [].slice.call(document.querySelectorAll('style'))
          .filter(style => {
            const text = style.innerText
            return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
          })
      styles.forEach(style => {
        const {innerText} = style
        if (typeof innerText !== 'string') return
        style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
      })
    },

    updateStyle(style, oldCluster, newCluster) {
      let newStyle = style
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
      })
      return newStyle
    },

    getCSSString(url, variable) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '')
            resolve()
          }
        }
        xhr.open('GET', url)
        xhr.send()
      })
    },

    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)

        if (tint === 0) { // when primary color is in its rgb space
          return [red, green, blue].join(',')
        } else {
          red += Math.round(tint * (255 - red))
          green += Math.round(tint * (255 - green))
          blue += Math.round(tint * (255 - blue))

          red = red.toString(16)
          green = green.toString(16)
          blue = blue.toString(16)

          return `#${red}${green}${blue}`
        }
      }

      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)

        red = Math.round((1 - shade) * red)
        green = Math.round((1 - shade) * green)
        blue = Math.round((1 - shade) * blue)

        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)

        return `#${red}${green}${blue}`
      }

      const clusters = [theme]
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
      }
      clusters.push(shadeColor(theme, 0.1))
      return clusters
    }
  }
}
</script>

<style scoped>

</style>
